<template>
  <ul class="collapsible popout">
    <li class="collapsible-margin active">
      <div class="collapsible-header">
        <i class="material-icons">flare</i> Solstice
      </div>
      <div class="collapsible-body tech row">
        <div class="col s12">
          <ul>
            <li>
              <b>The bot ignores the solstice keyword.</b>
            </li>
            <li>
              <b
                >Solstice keywords must be resolved as much as possible unless
                the card specifies that it is optional.</b
              >
            </li>
            <li>
              If you have multiple cards with solstice keywords activate them in
              the order you choose.
            </li>
            <li>
              Once you have resolved all your solstice keywords, take your next
              turn as normal to start the next round.
            </li>
          </ul>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
import { defineComponent, onMounted } from "vue";

export default defineComponent({
  setup() {
    onMounted(() => {
      var elems = document.querySelectorAll(".collapsible");
      window.M.Collapsible.init(elems, {});
    });
  },
});
</script>

<style></style>
